import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Utility } from 'src/app/core/common';
import { JobService } from 'src/app/services/job.service';
import { SharedService } from 'src/app/services/shared.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company-list',
  templateUrl: './company-list.component.html',
  styleUrls: ['./company-list.component.scss']
})
export class CompanyListComponent implements OnInit {
  constructor(private jobService: JobService, private spinner: SpinnerService,
    private sharedService: SharedService, private route: ActivatedRoute, private router: Router) { }
  set location(location: any) {
    this._location = location;
    if (!location.State) {
      delete this.params.l;
    } else {
      this.params.l = Utility.join('،', location.State, location.City);
    }
  }
  get location() { return this._location; }

  get previous() { return this.from > this.limit ? this.from - this.limit : 0; }
  get next() { return this.total == undefined || this.total > this.from + this.limit ? this.from + this.limit : null; }

  get page() { return Math.floor(this.from / this.limit) + 1; }
  get totalPage() { return Math.floor(this.total / this.limit) + 1; }

  get from() { return +(this.params.from || 0); }
  Utility = Utility;
  assetsUrl = environment.app.assetsUrl;

  params: any = {};
  pages: number[];
  title: string;
  moreFrom = 0;
  // jobSearchLink: string;
  loadingMore: boolean;

  nearbyUsers: any[];
  users: any[];
  total: number;
  criteria: any = {};
  limit = 20;

  _location: any = {};

  async ngOnInit() {
    this.route.params.subscribe(async params => {
      this.spinner.show();
      this.sharedService.scrollToTop();

      this.params = Object.assign({}, params);
      if (!this.params.l) { delete this.params.l; }
      if (!this.params.q) { delete this.params.q; }

      this.title = `شرکت‌ها ${this.params.q || ''}`;
      if (this.params.l) {
        const parts = this.params.l.split('،').filter(_ => _);
        this.criteria.State = parts[0];
        this.criteria.City = parts[1];
        this.title += ' در ' + (this.criteria.City ? 'شهر ' + this.criteria.City : 'استان ' + this.criteria.State);
      }
      this.criteria.Keyword = this.params.q;

      const result = await this.jobService.searchEmployer(this.params.l, this.params.q, this.from, this.limit);
      this.users = result.users;
      this.total = result.total;
      delete this.nearbyUsers;

      // if (this.total < this.limit && !!this.params.l)
      //   this.nearbyUsers = (await this.jobService.nearbyEmployer(this.params.l, this.params.q, (!this.params.q ? 1000 : 2000), 0, 30)).users;

      const split = !this.params.l ? ['', ''] : this.params.l.split('،').map(_ => _.trim());
      this.location = { State: split[0] || '', City: split[1] || '' };

      this.spinner.hide();

      this.seo();

      this.moreFrom = this.from + this.limit;
      // this.limit = 40;
    });
  }

  setParam() {
    if (!this.criteria.State) {
      delete this.params.l;
    } else {
      this.params.l = this.criteria.State + (this.criteria.City ? '،' + this.criteria.City : '');
    }
  }

  private seo() {
    this.sharedService.setTitle(this.title);
    this.sharedService.setDescriptionMeta(`صفحه ${this.page}/${this.totalPage} جستجو در ${this.title}`);
    this.sharedService.setKeywordsMeta(this.params.q, this.params.l);
    this.sharedService.removeLink('rel=\'prev\'');
    this.sharedService.removeLink('rel=\'next\'');
    if (this.next) {
      const href = this.router.serializeUrl(this.router.createUrlTree([this.getPage(this.next)], { relativeTo: this.route }));
      this.sharedService.addLink({ rel: 'next', href: href });
    }
    if (this.previous) {
      const href = this.router.serializeUrl(this.router.createUrlTree([this.getPage(this.previous)], { relativeTo: this.route }));
      this.sharedService.addLink({ rel: 'prev', href: href });
    }
    this.pages = Array(this.totalPage).fill(0).map((x, i) => i);

    // this.jobSearchLink = this.collectService.jobSearchLink(this.params.q, this.params.l, Object.assign({}, this.route.snapshot.queryParams, { from: this.moreFrom, limit: this.limit }));
  }

  async loadMore() {
    if (!this.users || this.loadingMore) { return; }
    this.loadingMore = true;
    this.spinner.show('more');
    try {
      if (this.moreFrom >= this.total) { return; }
      const result = await this.jobService.searchEmployer(this.params.l, this.params.q, this.moreFrom, this.limit);
      this.users.push(...result.users);
      this.total = result.total;

      this.seo();
      // this.ga.event('page', 'job-list', this.params.l + ' ' + this.params.q, this.moreFrom);

      this.moreFrom += this.limit;
    } finally {
      delete this.loadingMore;
      this.spinner.hide('more');
    }
  }

  ngOnDestroy(): void {
    this.sharedService.removeLink('rel=\'prev\'');
    this.sharedService.removeLink('rel=\'next\'');
  }
  getPage(from: number) {
    const params = Object.assign({}, this.params, { from });
    if (!from) { delete params.from; }
    return params;
  }

  companyLogo(logo: string) {
    if (!logo)
      return `/assets/images/clipart/avatar-company-1.svg`;
    return logo.startsWith('employer/') ? `${this.assetsUrl}${logo}` : `${this.assetsUrl}files/${logo}`;
  }

}
